<template>
  <div :class="[$style.base, { [$style.inputSmall]: small, [$style.inputTel]: type === 'tel', [$style.inputFilled]: !!modelValue }]">
    <div :class="$style.inputWrap">
      <Tel v-if="type === 'tel'" v-model="value" :class="$style.input" :style="`border-color: ${widgetSettings.color}`" :required="required" v-test="'tel-input'" />
      <input
        v-else
        v-model="value"
        @blur="$emit('blur')"
        :required="required"
        :class="$style.input"
        :style="`border-color: ${widgetSettings.color}`"
        autocomplete="on"
        :name="name"
        :type="type"
      />
      <div :class="$style.inputLabel" :style="`color: ${widgetSettings.color}`">
        {{ label }} <span v-if="required">*</span>
      </div>
      <div v-if="error" :class="$style.error" v-test="'input-error'">
        {{ error }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import widgetSettings from '@/widget-settings';
import { computed } from 'vue';
import Tel from './Tel.vue';

const props = withDefaults(
  defineProps<{
    error?: string;
    label: string;
    modelValue: string;
    required?: boolean;
    name: string;
    small?: boolean;
    type?: 'text' | 'email' | 'tel' | 'date';
  }>(),
  {
    type: 'text'
  }
);
const emit = defineEmits(['update:modelValue', 'blur']);

const value = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit('update:modelValue', value);
  }
});
</script>

<style lang="scss" module>
.base {
  &.inputSmall {
    width: calc(50% - #{$spacing * 0.5});
  }

  &:not(.inputSmall) {
    width: 100%;
  }
}

.label {
  margin-bottom: $spacing;
  font-weight: bold;
}

.userDetails {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: $spacing;
}

.inputWrap {
  position: relative;
  margin-bottom: $spacing;
}

.input {
  width: 100%;
  height: 51px;
  padding: 20px 10px 3px;
  border-radius: 8px;
  background-color: white;
  border: 1px solid;
  transition: border-color 0.15s;
  transition: color 0.12s;

  &:not(:focus):not(:focus-within) {
    border-color: $color-border-input !important;

    & + .inputLabel {
      color: #9f9f9f !important;
    }
  }

  &:focus, &:focus-within,
  .base.inputFilled & {
    & + .inputLabel {
      transform: translateY(-10%) scale(0.75);
    }
  }

  .base:not(.inputFilled):not(.inputTel) & {
    &:not(:focus):not(:focus-within) {
      color: transparent;

      &:-ms-input-placeholder {
        color: transparent;
      }

      &::-webkit-input-placeholder,
      &::placeholder {
        color: transparent;
      }
    }
  }
}

.error {
  color: $color-error;
  font-size: 13px;
  margin-top: 6px;
}

.inputLabel {
  display: flex;
  align-items: center;
  position: absolute;
  height: 100%;
  left: 0px;
  top: 0;
  padding: 10px;
  pointer-events: none;

  will-change: color, transform;
  transition:
    color 0.15s,
    transform 0.15s ease-out;
  transform-origin: 7% top;

  .base.inputTel & {
    transform: translateY(-10%) scale(0.75);
  }
}
</style>
